<template>
  <div class="allmodals">
    <!-- modal for wood-->

    <div id="wood1" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('wood1')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_wood1">

              <!-- Full-width images with number and caption text -->
              <div class="imySlideswood1 fade">
                <img alt="product image"  src="../assets/wood11.jpg" style="width:100%">
              </div>

              <div class="imySlideswood1 fade">
                <img alt="product image"  src="../assets/wood12.jpg" style="width:100%">
              </div>

              <a class="prev" v-on:click="iplusSlides(-1, 'wood1')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'wood1')">&#10095;</a>
            </div>
            <div class="idots" style="text-align:center">
              <span class="idot idotwood1"></span>
              <span class="idot idotwood1"></span>
            </div>
          </div>
          <br><br>
          <div><p></p></div>
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('wood1')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="wood2" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('wood2')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_wood2">

              <!-- Full-width images with number and caption text -->
              <div class="imySlideswood2 fade">
                <img alt="product image"  src="../assets/wood21.jpg" style="width:100%">
              </div>

              <div class="imySlideswood2 fade">
                <img alt="product image"  src="../assets/wood22.jpg" style="width:100%">
              </div>

              <a class="prev" v-on:click="iplusSlides(-1, 'wood2')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'wood2')">&#10095;</a>
            </div>
          </div>
          <div class="idots" style="text-align:center">
            <span class="idot idotwood2"></span>
            <span class="idot idotwood2"></span>
          </div>
          <br><br>
          <div><p class="modal_paragraph"><b>Bi-metal:</b> Πλατιά κορδέλα για την κοπή ξύλου.</p></div>
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('wood2')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="wood3" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('wood3')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_wood3">

              <!-- Full-width images with number and caption text -->
              <div class="imySlideswood3 fade">
                <img alt="product image"  src="../assets/wood31.jpg" style="width:100%">
              </div>

              <div class="imySlideswood3 fade">
                <img alt="product image"  src="../assets/wood32.jpg" style="width:100%">
              </div>

              <a class="prev" v-on:click="iplusSlides(-1, 'wood3')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'wood3')">&#10095;</a>
            </div>
          </div>
          <div class="idots" style="text-align:center">
            <span class="idot idotwood3"></span>
            <span class="idot idotwood3"></span>
          </div>
          <br><br>
          <div><p class="modal_paragraph"><b>Bi-metal:</b> Στενή κορδέλα για την κοπή ξύλου.</p></div>
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('wood3')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="wood4" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('wood4')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_wood4">

              <!-- Full-width images with number and caption text -->
              <div class="imySlideswood4 fade">
                <img alt="product image"  src="../assets/wood41.jpg" style="width:100%">
              </div>

              <div class="imySlideswood4 fade">
                <img alt="product image"  src="../assets/wood42.jpg" style="width:100%">
              </div>

              <a class="prev" v-on:click="iplusSlides(-1, 'wood4')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'wood4')">&#10095;</a>
            </div>
          </div>
          <div class="idots" style="text-align:center">
            <span class="idot idotwood4"></span>
            <span class="idot idotwood4"></span>
          </div>
          <br><br>
          <!-- <div><p></p></div> -->
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('wood4')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="wood5" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('wood5')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_wood5">

              <!-- Full-width images with number and caption text -->
              <div class="imySlideswood5 fade">
                <img alt="product image"  src="../assets/wood51.jpg" style="width:100%">
              </div>

              <div class="imySlideswood5 fade">
                <img alt="product image"  src="../assets/wood52.jpg" style="width:100%">
              </div>

              <a class="prev" v-on:click="iplusSlides(-1, 'wood5')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'wood5')">&#10095;</a>
            </div>
          </div>
          <div class="idots" style="text-align:center">
            <span class="idot idotwood5"></span>
            <span class="idot idotwood5"></span>
          </div>
          <br><br>
          <div><p class="modal_paragraph"><b>Starret:</b> Κορδέλα για την κοπή ξύλου.</p></div>
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('wood5')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="wood6" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('wood6')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_wood6">

              <!-- Full-width images with number and caption text -->
              <div class="imySlideswood6 fade">
                <img alt="product image"  src="../assets/wood61.jpg" style="width:100%">
              </div>

              <div class="imySlideswood6 fade">
                <img alt="product image"  src="../assets/wood62.jpg" style="width:100%">
              </div>

              <a class="prev" v-on:click="iplusSlides(-1, 'wood6')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'wood6')">&#10095;</a>
            </div>
          </div>
          <div class="idots" style="text-align:center">
            <span class="idot idotwood6"></span>
            <span class="idot idotwood6"></span>
          </div>
          <br><br>
          <!-- <div><p></p></div> -->
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('wood6')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="wood7" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('wood7')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_wood7">

              <!-- Full-width images with number and caption text -->
              <div class="imySlideswood7 fade">
                <img alt="product image"  src="../assets/wood71.jpg" style="width:100%">
              </div>

              <div class="imySlideswood7 fade">
                <img alt="product image"  src="../assets/wood72.jpg" style="width:100%">
              </div>

              <a class="prev" v-on:click="iplusSlides(-1, 'wood7')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'wood7')">&#10095;</a>
            </div>
          </div>
          <div class="idots" style="text-align:center">
            <span class="idot idotwood7"></span>
            <span class="idot idotwood7"></span>
          </div>
          <br><br>
          <!-- <div><p></p></div> -->
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('wood7')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="wood8" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('wood8')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_wood8">

              <!-- Full-width images with number and caption text -->
              <div class="imySlideswood8 fade">
                <img alt="product image"  src="../assets/wood82.jpg" style="width:100%">
              </div>

              <div class="imySlideswood8 fade">
                <img alt="product image"  src="../assets/wood81.jpg" style="width:100%">
              </div>

              <!-- Next and previous buttons -->
              <a class="prev" v-on:click="iplusSlides(-1, 'wood8')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'wood8')">&#10095;</a>
            </div>
          </div><div class="idots" style="text-align:center">
            <span class="idot idotwood8"></span>
            <span class="idot idotwood8"></span>
          </div>
<br><br>
          <!-- <div><p></p></div> -->
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('wood8')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="wood9" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('wood9')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_wood9">

              <!-- Full-width images with number and caption text -->
              <div class="imySlideswood9 fade">
                <img alt="product image"  src="../assets/wood91.jpg" style="width:100%">
              </div>

              <div class="imySlideswood9 fade">
                <img alt="product image"  src="../assets/wood92.jpg" style="width:100%">
              </div>

              <!-- Next and previous buttons -->
              <a class="prev" v-on:click="iplusSlides(-1, 'wood9')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'wood9')">&#10095;</a>
            </div>
          </div><div class="idots" style="text-align:center">
            <span class="idot idotwood9"></span>
            <span class="idot idotwood9"></span>
          </div>
<br><br>
          <div></div>
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('wood9')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="wood10" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px; text-align: center">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('wood10')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_wood10">

              <!-- Full-width images with number and caption text -->
              <div class="imySlideswood10 fade">
                <img alt="product image"  src="../assets/wood101.jpg" style="width:100%">
              </div>


              <!-- Next and previous buttons -->
              <a></a>
              <a></a>
            </div>
            <br><br>
            <div><p class="modal_paragraph"><b>Bandsaw:</b> Κορδέλα για την κοπή ξύλου.</p></div>
            <button type="button" class="w3-button w3-black"
                    v-on:click="ihidemodal('wood10')">Κλείσιμο <i class="fa fa-times-circle"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="wood11" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px; text-align: center">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('wood11')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_wood11">

              <!-- Full-width images with number and caption text -->
              <div class="imySlideswood11 fade">
                <img alt="product image"  src="../assets/wood111.jpg" style="width:100%">
              </div>
            </div>
            <!-- Next and previous buttons -->
            <a></a>
            <a></a>
          </div>
        </div>
        <br><br>
        <div><p class="modal_paragraph"></p></div>
        <button type="button" class="w3-button w3-black"
                v-on:click="ihidemodal('wood11')">Κλείσιμο <i class="fa fa-times-circle"></i>
        </button>
      </div>
    </div>

    <!-- end-of modal for wood-->

    <!-- modal for metal -->

    <div id="metal1" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('metal1')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_metal1">

              <!-- Full-width images with number and caption text -->
              <div class="imySlidesmetal1 fade">
                <img alt="product image"  src="../assets/metal11.jpg" style="width:100%">
              </div>

              <div class="imySlidesmetal1 fade">
                <img alt="product image"  src="../assets/metal12.jpg" style="width:100%">
              </div>

              <!-- Next and previous buttons -->
              <a class="prev" v-on:click="iplusSlides(-1, 'metal1')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'metal1')">&#10095;</a>
            </div>
          </div><div class="idots" style="text-align:center">
            <span class="idot idotmetal1"></span>
            <span class="idot idotmetal1"></span>
          </div>
<br><br>
          <!-- <div><p></p></div> -->
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('metal1')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="metal2" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('metal2')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_metal2">

              <!-- Full-width images with number and caption text -->
              <div class="imySlidesmetal2 fade">
                <img alt="product image"  src="../assets/metal21.jpg" style="width:100%">
              </div>

              <div class="imySlidesmetal2 fade">
                <img alt="product image"  src="../assets/metal22.jpg" style="width:100%">
              </div>

              <!-- Next and previous buttons -->
              <a class="prev" v-on:click="iplusSlides(-1, 'metal2')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'metal2')">&#10095;</a>
            </div>
          </div><div class="idots" style="text-align:center">
            <span class="idot idotmetal2"></span>
            <span class="idot idotmetal2"></span>
          </div>
<br><br>
          <!-- <div><p></p></div> -->
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('metal2')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="metal3" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px; text-align: center">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('metal3')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_metal3">

              <!-- Full-width images with number and caption text -->
              <div class="imySlidesmetal3 fade">
                <img alt="product image"  src="../assets/metal31.jpg" style="width:100%">
              </div>
            </div>

            <!-- Next and previous buttons -->
            <a class="prev" v-on:click="iplusSlides(-1, 'metal3')">&#10094;</a>
            <a class="next" v-on:click="iplusSlides(1, 'metal3')">&#10095;</a>
          </div>
        </div>
        <br><br>
        <!-- <div><p></p></div> -->
        <button type="button" class="w3-button w3-black"
                v-on:click="ihidemodal('metal3')">Κλείσιμο <i class="fa fa-times-circle"></i>
        </button>
      </div>
    </div>
    <div id="metal4" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px; text-align: center">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('metal4')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_metal4">

              <!-- Full-width images with number and caption text -->
              <div class="imySlidesmetal4 fade">
                <img alt="product image"  src="../assets/metal41.jpg" style="width:100%">
              </div>
            </div>

            <!-- Next and previous buttons -->
            <a class="prev" v-on:click="iplusSlides(-1, 'metal4')">&#10094;</a>
            <a class="next" v-on:click="iplusSlides(1, 'metal4')">&#10095;</a>
          </div>
        </div>
        <br><br>
        <div><p class="modal_paragraph"><b>HSS DMO5:</b> Δίσκος για την κοπή μετάλλου.</p></div>
        <button type="button" class="w3-button w3-black"
                v-on:click="ihidemodal('metal4')">Κλείσιμο <i class="fa fa-times-circle"></i>
        </button>
      </div>
    </div>

    <!-- end-of modal for metal -->

    <!-- modal for frozen-->

    <div id="frozen1" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('frozen1')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_frozen1">

              <!-- Full-width images with number and caption text -->
              <div class="imySlidesfrozen1 fade">
                <img alt="product image"  src="../assets/frozen11.jpg" style="width:100%">
                <div class="text">1 / 2</div>
              </div>

              <div class="imySlidesfrozen1 fade">
                <img alt="product image"  src="../assets/frozen12.jpg" style="width:100%">
                <div class="text">2 / 2</div>
              </div>

              <!-- Next and previous buttons -->
              <a class="prev" v-on:click="iplusSlides(-1, 'frozen1')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'frozen1')">&#10095;</a>
            </div>
          </div><div class="idots" style="text-align:center">
            <span class="idot idotfrozen1"></span>
            <span class="idot idotfrozen1"></span>
          </div>
<br><br>
          <!-- <div><p></p></div> -->
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('frozen1')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- end-of modal for frozen -->

    <!-- modal for knives -->

    <div id="knives1" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('knives1')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_knives1">

              <!-- Full-width images with number and caption text -->
              <div class="imySlidesknives1 fade">
                <img alt="product image"  src="../assets/knives11.jpg" style="width:100%">
              </div>

              <div class="imySlidesknives1 fade">
                <img alt="product image"  src="../assets/knives12.jpg" style="width:100%">
              </div>

              <!-- Next and previous buttons -->
              <a class="prev" v-on:click="iplusSlides(-1, 'knives1')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'knives1')">&#10095;</a>
            </div>
          </div><div class="idots" style="text-align:center">
            <span class="idot idotknives1"></span>
            <span class="idot idotknives1"></span>
          </div>
<br><br>
          <!-- <div><p></p></div> -->
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('knives1')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>

        </div>
      </div>
    </div>
    <div id="knives2" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('knives2')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_knives2">

              <!-- Full-width images with number and caption text -->
              <div class="imySlidesknives2 fade">
                <img alt="product image"  src="../assets/knives21.jpg" style="width:100%">
              </div>

              <div class="imySlidesknives2 fade">
                <img alt="product image"  src="../assets/knives22.jpg" style="width:100%">
              </div>

              <!-- Next and previous buttons -->
              <a class="prev" v-on:click="iplusSlides(-1, 'knives2')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'knives2')">&#10095;</a>
            </div>
          </div><div class="idots" style="text-align:center">
            <span class="idot idotknives2"></span>
            <span class="idot idotknives2"></span>
          </div>
<br><br>
          <!-- <div><p></p></div> -->
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('knives2')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="knives3" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('knives3')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_knives3">

              <!-- Full-width images with number and caption text -->
              <div class="imySlidesknives3 fade">
                <img alt="product image"  src="../assets/knives32.jpg" style="width:100%">
              </div>

              <div class="imySlidesknives3 fade">
                <img alt="product image"  src="../assets/knives31.jpg" style="width:100%">
              </div>

              <!-- Next and previous buttons -->
              <a class="prev" v-on:click="iplusSlides(-1, 'knives3')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'knives3')">&#10095;</a>
            </div>
          </div>
          <div class="idots" style="text-align:center">
            <span class="idot idotknives3"></span>
            <span class="idot idotknives3"></span>
          </div>
<br><br>
          <div><p>Λεπίδα κοπής Polar 115 . Κατασκευασμένη από υλικό Standard Steel (SS).
            Υψηλή αντοχή στη φθορά. Κατάλληλο για κοπή όλων των ειδών
            χαρτιού, χαρτονιών, φύλλων, ελαστικών και άλλων υλικών για τη βιομηχανία εκτύπωσης και χαρτιού.</p></div>
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('knives3')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="knives4" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('knives4')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_knives4">

              <!-- Full-width images with number and caption text -->
              <div class="imySlidesknives4 fade">
                <img alt="product image"  src="../assets/knives41.jpg" style="width:100%">
              </div>

              <div class="imySlidesknives4 fade">
                <img alt="product image"  src="../assets/knives42.jpg" style="width:100%">
              </div>

              <!-- Next and previous buttons -->
              <a class="prev" v-on:click="iplusSlides(-1, 'knives4')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'knives4')">&#10095;</a>
            </div>
          </div><div class="idots" style="text-align:center">
            <span class="idot idotknives4"></span>
            <span class="idot idotknives4"></span>
          </div>
<br><br>
          <!-- <div><p></p></div> -->
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('knives4')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="knives5" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('knives5')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_knives5">

              <!-- Full-width images with number and caption text -->

              <div class="imySlidesknives5 fade">
                <img alt="product image"  src="../assets/tersa_01.png" style="width:100%">
              </div>

              <div class="imySlidesknives5 fade">
                <img alt="product image"  src="../assets/tersa_00.jpg" style="width:100%">
              </div>

              <!-- Next and previous buttons -->
              <a class="prev" v-on:click="iplusSlides(-1, 'knives5')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'knives5')">&#10095;</a>
            </div>
          </div><div class="idots" style="text-align:center">
            <span class="idot idotknives5"></span>
            <span class="idot idotknives5"></span>
          </div>
<br><br>
          <div><p><b>Tersa λεπίδες:</b>
            Η μάρκα Tersa αντιπροσωπεύει υψηλή ποιότητα.

            Οι λεπίδες Tersa συνδυάζουν ασφάλεια, ποιότητα την ευκολία χρήσης όπως καμία άλλη λεπίδα.
            Μέσα σε λίγα δευτερόλεπτα μπορείτε εύκολα να αλλάξετε τις αναστρέψιμες λεπίδες στο μηχάνημά σας.</p></div>
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('knives5')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- end-of modal for knives -->

    <!-- modal for rest  -->

    <div id="rest1" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('rest1')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_rest1">

              <!-- Full-width images with number and caption text -->
              <div class="imySlidesrest1 fade">
                <img alt="product image"  src="../assets/rest11.jpg" style="width:100%">
              </div>

              <div class="imySlidesrest1 fade">
                <img alt="product image"  src="../assets/rest12.jpg" style="width:100%">
              </div>

              <!-- Next and previous buttons -->
              <a class="prev" v-on:click="iplusSlides(-1, 'rest1')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'rest1')">&#10095;</a>
            </div>
          </div><div class="idots" style="text-align:center">
            <span class="idot idotrest1"></span>
            <span class="idot idotrest1"></span>
          </div>
<br><br>
          <div><p><b>Οδηγός πριονοκορδέλας πάνω - κάτω:</b>
            Τάκος πριονοκορδέλας που μπορεί να κατασκευαστεί σε οποιαδήποτε διάσταση για να ταιριάζει με όλους τους τύπους πριονοκορδέλας.
            Με τακάκια βακελίτη για μεγαλύτερη αντοχή.</p></div>
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('rest1')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="rest2" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('rest2')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_rest2">

              <!-- Full-width images with number and caption text -->
              <div class="imySlidesrest2 fade">
                <img alt="product image"  src="../assets/rest21.jpg" style="width:100%">
              </div>

              <div class="imySlidesrest2 fade">
                <img alt="product image"  src="../assets/rest22.jpg" style="width:100%">
              </div>

              <!-- Next and previous buttons -->
              <a class="prev" v-on:click="iplusSlides(-1, 'rest2')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'rest2')">&#10095;</a>
            </div>
          </div>
          <div class="idots" style="text-align:center">
            <span class="idot idotrest2"></span>
            <span class="idot idotrest2"></span>
          </div>
<br><br>
          <!-- <div><p></p></div> -->
          <button type="button" class="w3-button w3-black"
                  v-on:click="ihidemodal('rest2')">Κλείσιμο <i class="fa fa-times-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="rest3" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px; text-align: center">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('rest3')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_rest3">

              <!-- Full-width images with number and caption text -->
              <div class="imySlidesrest3 fade">
                <img alt="product image"  src="../assets/rest31.jpg" style="width:100%">
              </div>

            </div>

            <!-- Next and previous buttons -->
            <a class="prev" v-on:click="iplusSlides(-1, 'rest3')">&#10094;</a>
            <a class="next" v-on:click="iplusSlides(1, 'rest3')">&#10095;</a>
          </div>
        </div>
<br><br>
        <!-- <div><p></p></div> -->
        <button type="button" class="w3-button w3-black"
                v-on:click="ihidemodal('rest3')">Κλείσιμο <i class="fa fa-times-circle"></i>
        </button>
      </div>
    </div>
    <div id="rest4" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px; text-align: center">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('rest4')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_rest4">

              <!-- Full-width images with number and caption text -->
              <div class="imySlidesrest4 fade">
                <img alt="product image"  src="../assets/rest41.jpg" style="width:100%">
              </div>
            </div>

            <!-- Next and previous buttons -->
            <a class="prev" v-on:click="iplusSlides(-1, 'rest4')">&#10094;</a>
            <a class="next" v-on:click="iplusSlides(1, 'rest4')">&#10095;</a>
          </div>
        </div>
<br><br>
        <!-- <div><p></p></div> -->
        <button type="button" class="w3-button w3-black"
                v-on:click="ihidemodal('rest4')">Κλείσιμο <i class="fa fa-times-circle"></i>
        </button>
      </div>
    </div>
    <div id="rest5" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px; text-align: center">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('rest5')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_rest5">

              <!-- Full-width images with number and caption text -->
              <div class="imySlidesrest5 fade">
                <img alt="product image"  src="../assets/rest51.jpg" style="width:100%">
              </div>
            </div>

            <!-- Next and previous buttons -->
            <a class="prev" v-on:click="iplusSlides(-1, 'rest5')">&#10094;</a>
            <a class="next" v-on:click="iplusSlides(1, 'rest5')">&#10095;</a>
          </div>
        </div>
<br><br>
        <!-- <div><p></p></div> -->
        <button type="button" class="w3-button w3-black"
                v-on:click="ihidemodal('rest5')">Κλείσιμο <i class="fa fa-times-circle"></i>
        </button>
      </div>
    </div>
    <div id="rest6" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px; text-align: center">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('rest6')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_rest6">

              <!-- Full-width images with number and caption text -->
              <div class="imySlidesrest6 fade">
                <img alt="product image"  src="../assets/rest61.jpg" style="width:100%">
              </div>
            </div>
            <!-- Next and previous buttons -->
            <a class="prev" v-on:click="iplusSlides(-1, 'rest6')">&#10094;</a>
            <a class="next" v-on:click="iplusSlides(1, 'rest6')">&#10095;</a>
          </div>
        </div>
<br><br>
        <!-- <div><p></p></div> -->
        <button type="button" class="w3-button w3-black"
                v-on:click="ihidemodal('rest6')">Κλείσιμο <i class="fa fa-times-circle"></i>
        </button>
      </div>
    </div>
    <div id="rest7" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom" style="padding:32px; text-align: center">
        <div class="w3-container w3-white w3-center">
          <i v-on:click="ihidemodal('rest7')"
             class="fa fa-remove w3-right w3-button w3-transparent w3-xxlarge"></i>

          <div class="">
            <!-- Slideshow container -->
            <div class="slideshow-container modal_slideshow_container_rest7">

              <!-- Full-width images with number and caption text -->
              <div class="imySlidesrest7 fade">
                <img alt="product image"  src="../assets/rest71.jpg" style="width:100%">
              </div>
              <div class="imySlidesrest7 fade">
                <img alt="product image"  src="../assets/rest72.jpg" style="width:100%">
              </div>

              <!-- Next and previous buttons -->
              <a class="prev" v-on:click="iplusSlides(-1, 'rest7')">&#10094;</a>
              <a class="next" v-on:click="iplusSlides(1, 'rest7')">&#10095;</a>
            </div>
            </div>
          <div class="idots" style="text-align:center">
            <span class="idot idotrest7"></span>
            <span class="idot idotrest7"></span>
          </div>
        </div>
        <br><br>
        <!-- <div><p></p></div> -->
        <button type="button" class="w3-button w3-black"
                v-on:click="ihidemodal('rest7')">Κλείσιμο <i class="fa fa-times-circle"></i>
        </button>
      </div>
    </div>

    <!-- end-of modal for rest -->


  </div>
</template>

<script>
  export default {
    name: "allmodals",
    data() {
      return {
        islideIndex: 1,
        openedModalId: "none",
        currId: ""
      }
    },
    mounted: function () {
      var container = document.querySelector('.modal_slideshow_container_wood1');
      var listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'wood1');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'wood1');
        }
      });
      container = document.querySelector('.modal_slideshow_container_wood2');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'wood2');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'wood2');
        }
      });
      container = document.querySelector('.modal_slideshow_container_wood3');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'wood3');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'wood3');
        }
      });
      container = document.querySelector('.modal_slideshow_container_wood4');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'wood4');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'wood4');
        }
      });
      container = document.querySelector('.modal_slideshow_container_wood5');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'wood5');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'wood5');
        }
      });
      container = document.querySelector('.modal_slideshow_container_wood6');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'wood6');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'wood6');
        }
      });
      container = document.querySelector('.modal_slideshow_container_wood7');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'wood7');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'wood7');
        }
      });
      container = document.querySelector('.modal_slideshow_container_wood8');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'wood8');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'wood8');
        }
      });
      container = document.querySelector('.modal_slideshow_container_wood9');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'wood9');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'wood9');
        }
      });
      container = document.querySelector('.modal_slideshow_container_metal1');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'metal1');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'metal1');
        }
      });
      container = document.querySelector('.modal_slideshow_container_metal2');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'metal2');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'metal2');
        }
      });
      container = document.querySelector('.modal_slideshow_container_frozen1');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'frozen1');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'frozen1');
        }
      });
      container = document.querySelector('.modal_slideshow_container_knives1');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'knives1');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'knives1');
        }
      });
      container = document.querySelector('.modal_slideshow_container_knives2');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'knives2');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'knives2');
        }
      });
      container = document.querySelector('.modal_slideshow_container_knives3');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'knives3');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'knives3');
        }
      });
      container = document.querySelector('.modal_slideshow_container_knives4');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'knives4');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'knives4');
        }
      });
      container = document.querySelector('.modal_slideshow_container_knives5');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'knives5');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'knives5');
        }
      });
      container = document.querySelector('.modal_slideshow_container_rest1');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'rest1');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'rest1');
        }
      });
      container = document.querySelector('.modal_slideshow_container_rest2');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'rest2');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'rest2');
        }
      });
      container = document.querySelector('.modal_slideshow_container_rest7');
      listener = SwipeListener(container);
      container.addEventListener('swipe', (e) => {
        if (e.detail.directions.left) {
          this.iplusSlides(1, 'rest7');
        }else if (e.detail.directions.right) {
          this.iplusSlides(-1, 'rest7');
        }
      });
    },
    methods: {
      consolelog: function () {
        //console.log(this.islideIndex)
      },
      ishowmodal: function (modalId) {
        document.getElementById(modalId).style.display = 'block'
      },
      ihidemodal: function (modalId) {
        document.getElementById(modalId).style.display = 'none'
      },
      iplusSlides: function (n, mid) {
        this.ishowSlides(this.islideIndex += n, mid);
        ////console.log(this.islideIndex+"  "+mid);
      },
      icurrentSlide: function (n, mid) {
        this.openedModalId = mid;
        //console.log('.modal_slideshow_container_'+mid)
        this.ishowSlides(this.islideIndex = n, mid);
      },
      ishowSlides: function (n, mid) {
        let i;
        //console.log(mid)
        let slides = document.getElementsByClassName("imySlides" + mid);
        let dots = document.getElementsByClassName("idot"+mid);
        if (n > slides.length) {
          this.islideIndex = 1
        }
        if (n < 1) {
          this.islideIndex = slides.length
        }
        for (i = 0; i < slides.length; i++) {
          slides[i].style.display = "none";
        }
        for (i = 0; i < dots.length; i++) {
          dots[i].className = dots[i].className.replace(" active", "");
        }
        slides[this.islideIndex - 1].style.display = "block";
        try{
          dots[this.islideIndex-1].className += " active";
        }catch (e) {

        }
      }
    }
  }
</script>

<style scoped>
  * {
    box-sizing: border-box
  }

  /* Slideshow container */
  .slideshow-container {
    max-width: 1000px;
    position: relative;
    margin: auto;
  }

  /* Hide the images by default */
  .imySlides {
    display: none;
  }

  /* Next & previous buttons */
  .prev, .next {
    cursor: pointer;
    position: absolute;
    top: 50%;
    width: auto;
    margin-top: -22px;
    padding: 16px;
    color: white;
    font-weight: bold;
    font-size: 18px;
    transition: 0.6s ease;
    border-radius: 0 3px 3px 0;
    user-select: none;
  }

  .w3-button w3-black {
    background-color: whitesmoke;
    color: black;
    float: right;
    padding: 7px;

  }

  .w3-button w3-black:hover {
    box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24), 0 17px 50px 0 rgba(0, 0, 0, 0.19);

  }

  .prev {
    left: 0;
  }

  /* Position the "next button" to the right */
  .next {
    right: 0;
    border-radius: 3px 0 0 3px;
  }

  /* On hover, add a black background color with a little bit see-through */
  .prev:hover, .next:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }

  /* Caption text */
  .text {
    color: #f2f2f2;
    font-size: 15px;
    padding: 8px 12px;
    position: absolute;
    bottom: 8px;
    width: 100%;
    text-align: center;
  }

  /* Number text (1/3 etc) */
  .numbertext {
    color: #f2f2f2;
    font-size: 12px;
    padding: 8px 12px;
    position: absolute;
    top: 0;
  }

  /* The dots/bullets/indicators */
  .idot {
    cursor: pointer;
    height: 10px;
    width: 10px;
    margin: 0 2px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    transition: background-color 0.6s ease;
  }

  .active, .idot:hover {
    background-color: #717171;
  }

  .slideshow-container {
    max-width: 600px;
  }

  /* Fading animation */
  .fade {
    -webkit-animation-name: fade;
    -webkit-animation-duration: .5s;
    animation-name: fade;
    animation-duration: .5s;
  }

  .modal_paragraph{
    margin-top: -23px;
  }

  @-webkit-keyframes fade {
    from {
      opacity: .4
    }
    to {
      opacity: 1
    }
  }

  @keyframes fade {
    from {
      opacity: .4
    }
    to {
      opacity: 1
    }
  }

  @media only screen and (max-width: 600px) {
    .prev{
      display: none;
    }
    .next{
      display: none;
    }

  }

  @media only screen and (max-width: 992px) {
    .fa-remove{
      display: none;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/allmodals.vue